import React from 'react';
import ContentLayout from './ContentLayout';
import { ContentDataSource } from '../data';
import { Space, Popover } from 'antd';

class Content extends React.PureComponent {
  // 新增状态管理回到顶部按钮的显示
  state = {
    showBackTop: false
  };

  getDuration = (e) => {
    if (e.key === 'map') {
      return 800;
    }
    return 1000;
  };

  // 处理滚动事件的方法
  handleScroll = () => {
    // 当滚动超过300px时显示按钮，否则隐藏
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.setState({
      showBackTop: scrollTop > 300
    });
  };

  // 组件挂载时添加滚动监听
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  // 组件卸载时移除滚动监听，避免内存泄漏
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    const { isMobile } = this.props;
    const { showBackTop } = this.state;

    return (
      <>
        {
          ContentDataSource.map((item, i) => (
            <ContentLayout key={i} isMobile={isMobile} data={item} />
          ))
        }
        {!isMobile && <div className='affix'>
          <Space direction='vertical'>
            <a href='https://xiaodun.com/register' className='affix-btn affix-shenqing'>立即<br></br>申请</a>
            <Popover placement="left" content={
              <Space size={6} direction='vertical'>
                <div>
                  电话咨询
                  <p>400-068-9796</p>
                </div>
                <div>
                  专有云咨询
                  <p>400-068-9796转3</p>
                </div>
                <div>公有云咨询
                  <p>400-068-9796转2</p>
                </div>
                <div>售前咨询<p>400-068-9796转1</p></div>
              </Space>
            }>
              <div className='affix-btn affix-tel'></div>
            </Popover>
            <a target='_blank' href='https://tongdun.com/support/customerService' className='affix-btn affix-sales'></a>

            {/* 根据showBackTop状态控制按钮显示/隐藏 */}
            <div
              onClick={() => {
                window.scrollTo({
                  top: 0,
                  behavior: 'smooth'
                });
              }}
              className={`affix-btn affix-backTop ${showBackTop ? 'show' : 'hide'}`}
              style={{
                // 也可以直接在这里用内联样式控制显示
                opacity: showBackTop ? '1' : '0'
              }}
            ></div>
          </Space>
        </div>}

      </>
    );
  }
}

export default Content;
